import React from "react";
import SkeletonText from "./SkeletonText";

const SkeletonCard = ({
  children,
  className = "",
  padding = "p-6",
  showHeader = false,
  headerTitle = true,
  headerSubtitle = true,
}) => {
  return (
    <div className={`bg-white shadow rounded-lg ${padding} ${className}`}>
      {showHeader && (
        <div className="mb-4 space-y-2">
          {headerTitle && <SkeletonText size="lg" width="1/3" />}
          {headerSubtitle && <SkeletonText size="sm" width="1/2" />}
        </div>
      )}
      {children}
    </div>
  );
};

export default SkeletonCard;
